module.exports = __webpack_public_path__ + "img/info.4ce31d81.svg";